module.exports = __webpack_public_path__ + "img/img8.e0dc5362.svg";